import { z } from 'zod';
export const GenAIPlatformLinkedTenantSchema = z.object({
    tenant: z.object({
        identifier: z.string(),
        name: z.string(),
    }),
    account: z.object({
        identifier: z.string(),
        name: z.string(),
    }),
});
